import styled from '@emotion/styled'

import { calcRem } from 'component-library/__styling/style-functions'
import { colors, metrics } from 'component-library/__styling/settings'
import { themedValue } from 'component-library/__styling/themed-value'
import { ThemeMargins } from 'component-library/__styling/settings/metrics'

export interface GridProps {
    verticalSpacing: keyof ThemeMargins | undefined
}

export const StyledOscar = styled('div')<GridProps>(
    {
        margin: '0 auto',
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        alignContent: 'stretch',
        flexDirection: 'column',
        flexGrow: 1, // Added so that it works with additional component wrapper from product
    },
    ({ theme, verticalSpacing }) => ({
        backgroundColor: themedValue(theme, {
            perthnow: colors.white,
            thewest: 'transparent',
            fallback: undefined,
        }),
        marginBottom: verticalSpacing && calcRem(theme.margins[verticalSpacing]),
    })
)

export const StyledHeader = styled('div')(
    {
        display: 'block',
        width: '100%',
    },
    ({ theme }) => ({
        marginBottom: themedValue(theme, {
            perthnow: undefined,
            fallback: calcRem(theme.margins.md),
        }),
    })
)

export const StyledGridItem = styled('div')({
    display: 'flex',
    justifyContent: 'flex-start',
    flexGrow: 1,
    flexShrink: 1,
    width: '100%',
    maxWidth: '100%',
    alignItems: 'flex-start',
    flex: '0 0 auto',
})

export const StyledGridList = styled('ul')(
    {
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignSelf: 'stretch',
        alignItems: 'stretch',
        width: '100%',
        maxWidth: '100%',
        margin: 0,
    },
    ({ theme }) => ({
        borderBottom: themedValue(theme, {
            perthnow: `1px solid ${colors.perthnow.greyMarble}`,
            fallback: undefined,
        }),
        background: themedValue(theme, { thewest: colors.white, fallback: undefined }),
        padding: themedValue(theme, {
            perthnow: `${calcRem(metrics.perthnow.margins.sm)} 0`,
            fallback: 0,
        }),
    })
)
